import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledLanguageSelector = styled.div`
  display: flex;
  gap: 10px;

  .option {
    border: 1px solid ${Colors.lighterGray};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 5px 10px;
    background-color: ${Colors.backgroundPaleBlue};
    border-radius: 20px;

    &.active {
      position: relative;
      background-color: ${Colors.primary};
      color: white;

      .flag {
        border: 1px solid white;
        border-radius: 50%;
      }
    }

    .flag {
      display: inline-flex;
      border: 1px solid white;
      border-radius: 50%;
    }
  }

  &.small {
    justify-content: center;
    padding: 0px 20px;
    gap: 0;
    border-radius: 10px;

    .option {
      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-width: 0;
      }
      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-width: 0;
      }
      .text {
        display: none;
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
    width: 100%;

    .option {
      flex: 1;
    }
  }
`;
